<template>
  <section id="contact" class="section">
    <div class="content-670">
      <h2 class="title">CONTÁCTAME</h2>
      <p>Ha sido un viaje maravillo, espero haber respondido tus dudas sobre ¿Quién es Elis?, si sientes que no 😱, contáctame y seguiremos charlando.</p>
    </div>
    <ul class="about-info" data-threshold="0 0" data-jarallax-element="40 0">
      <li>
        <h6>CORREO ELECTRÓNICO</h6>
        <a href="mailto:mr.daza@ingenieros.com">mr.daza@ingenieros.com</a>
      </li>
      <li>
        <h6>ROL DESEMPEÑADO</h6>
        <span>Full Stack Developer</span>
      </li>
      <li>
        <h6>TELEFÓNO</h6>
        <a href="tel:+573016525948">(+57) 301 652 5948</a>
      </li>
    </ul>
    <div class="content-670">
      <div v-if="errored" class="helper-error">
        <p>Lo sentimos, no es posible enviar la información en este momento, por favor intente nuevamente más tarde</p>
      </div>
      <div v-else>
        <div v-if="loading">
          <img src="../assets/images/sendmail.gif" alt="MrDaza Send Mail" class="imgMail" >
        </div>
        <div v-else>
          <form class="contact-form" @submit.prevent="checkForm" novalidate="true">
            <div class="form-group">
              <label for="contact-name" class="p">Nombres</label>
              <input id="contact-name" type="text" v-model="form.contact_name" required  name="your-name" placeholder="Nombre" class="validate" />
              <small class="form-text text-muted helper-error" v-if="errors.name.val == 0">{{errors.name.text}}</small>
              <small class="form-text text-muted helper-ok" v-else>{{errors.name.text}}</small>
            </div>
            <div class="form-group">
              <label for="contact-email">Correo Electrónico</label>
              <input id="contact-email" type="email" v-model="form.contact_email" required name="your-email" placeholder="Correo Electrónico" class="validate" />
              <small class="form-text text-muted helper-error" v-if="errors.email.val == 0">{{errors.email.text}}</small>
              <small class="form-text text-muted helper-ok" v-else>{{errors.email.text}}</small>
            </div>
            <div class="form-group">
              <label for="contact-subject">MENSAJE</label>
              <textarea id="contact-subject" type="text" v-model="form.contact_subject" required name="your-subject" placeholder="MENSAJE" data-lenght="255" ></textarea>
              <small class="form-text text-muted helper-error" v-if="!errors.subject.val">{{errors.subject.text}}</small>
              <small class="form-text text-muted helper-ok" v-else>{{errors.subject.text}}</small>
            </div>
            <p class="contact-submit-holder">
              <input type="submit" value="SEND">
            </p>
          </form>
        </div>
      </div>
    </div>
    <ul class="serv-link-cover block-right jarallax-contact jarallax" data-jarallax-element="-10 -10" data-jarallax data-speed="0.2">
      <li>
        <a href="#portfolio">DOWNLOAD CV</a>
      </li>
      <li>
        <a href="#portfolio">MY PORTFOLIO</a>
      </li>
    </ul>
  </section>
</template>

<script>
import axios from "axios";
export default {
  name: "page-contact",
  mounted(){

  },
  data() {
    return {
      errors:{
        name:{
          val:null,
          text:null
        },
        email:{
          val:null,
          text:null
        },
        subject:{
          val:null,
          text:null
        },
      },
      form:{
        contact_name:null,
        contact_email:null,
        contact_subject:null,
      },
      loading: false,
      errored: false,
      msn: "Pagína Contacto"
    };
  },
  methods:{
    checkForm:function (event){
      if (!this.form.contact_name || this.form.contact_name.trim()=="") {
        this.errors.name.val = 0
        this.errors.name.text= 'El nombre es obligatorio.'
        this.form.contact_name = "";
      }else if(this.form.contact_name.trim().length <= 4 || this.form.contact_name.trim().length >= 50){
        this.errors.name.val = 0
        this.errors.name.text= 'El nombre debe contener mas de 4 Y menos de 50 caracteres'
        this.form.contact_name = this.form.contact_name.trim()
      }else{
        //console.log("name = "+this.form.contact_name.trim().length);
        this.errors.name.val = 1
        this.errors.name.text="!OK"
      }


      if (!this.form.contact_email || this.form.contact_email.trim()=="") {
        this.errors.email.val = 0
        this.errors.email.text = 'El correo electrónico es obligatorio.'
        this.form.contact_email = ""
      } else if (!this.validEmail( this.form.contact_email.trim() )) {
        this.errors.email.val = 0
        this.errors.email.text = 'El correo electrónico debe ser válido.'
        this.form.contact_email = this.form.contact_email.trim()
      }else{
        //console.log("email = "+this.form.contact_email.trim().length);
        this.errors.email.val = 1
        this.errors.email.text = "OK!"
      }

      if (!this.form.contact_subject || this.form.contact_subject.trim()=="") {
        this.errors.subject.val = 0
        this.errors.subject.text= 'El mensaje es obligatorio.'
        this.form.contact_subject = "";
      }else if(this.form.contact_subject.trim().length <= 20 || this.form.contact_subject.trim().length >= 255){
        this.errors.subject.val = 0
        this.errors.subject.text= 'El mensaje debe contener mas de 20 Y menos de 255 caracteres'
        this.form.contact_subject = this.form.contact_subject.trim()
      }else{
        //console.log("subject = "+this.form.contact_subject.trim().length);
        this.errors.subject.val = 1
        this.errors.subject.text="!OK"
      }

      event.preventDefault();
      if(this.errors.subject.val == 1 && this.errors.email.val == 1 && this.errors.name.val == 1){
        this.sendMail();
      }
      //alert(JSON.stringify(this.from))
      //console.log(JSON.stringify(this.from));
    },
    sendMail(){
      //const apiUrl = 'https://us-central1-ih-sites.cloudfunctions.net/sendContactMrDaza?';
      let apiUrl = 'https://us-central1-ih-sites.cloudfunctions.net/sendContactBeta?';
      apiUrl = apiUrl + 'name='+encodeURIComponent(this.form.contact_name)
      apiUrl = apiUrl + '&email='+ encodeURIComponent(this.form.contact_email)
      apiUrl = apiUrl + '&subject='+encodeURIComponent(this.form.contact_subject)
      this.loading = true

      axios
        .get(apiUrl)
        .then(request => {
          const html = request.data;
          //console.log("Status = " + html.status + " totalResult " + html.messages);
          if (html.status == "ok") {
            this.loading = false
          } else {
            this.error = true;
          }
          //console.log(html);
        })
        .catch(() => {
          //console.log("error:" + error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    formClear(){
      this.form.contact_name = "",
      this.form.contact_email = "",
      this.form.contact_subject=""
    },
    validEmail: function (email) {
      // eslint-disable-next-line no-useless-escape
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>

<style lang="scss" scoped>
  .helper-ok, .helper-error {
    font-size: 10px;
    font-weight: 400;
  }
  .helper-error{
    color: #f44647;
  }

  .helper-ok{
    color: #09df49;
  }

  .contact-name label{
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    line-height: 25px;
    letter-spacing: 3px;
    color: #000;
    background-color: transparent;
    border: 0;
    border-bottom: 2px solid;
    padding-top: 13px;
    padding-bottom: 0px;
    padding-left: 0;
    margin: 10px 0px 0px 0px;
    height: 28px;
    width: 100% !important;
    box-sizing: initial;
  }
</style>
